import { CheckIcon } from "lucide-react";

import { ContextMenuItem } from "@/components/ui/context-menu";

const RequiredInput: React.FC<{
  rightClickedElement: HTMLElement;
  onChange?: (isRequired: boolean) => void;
}> = ({ rightClickedElement, onChange }) => {
  const isRequired = rightClickedElement.hasAttribute("required");
  console.log(isRequired);
  

  const toggle = () => {
    const next = !rightClickedElement.hasAttribute("required");

    if (next) {
      rightClickedElement.setAttribute("required", "true");
    } else {
      rightClickedElement.removeAttribute("required");
    }

    onChange?.(next);
  };

  return (
    <ContextMenuItem
      className="flex items-center justify-between"
      onClick={toggle}
    >
      اجباری
      {isRequired && <CheckIcon size={16} className="text-primary" />}
    </ContextMenuItem>
  );
};

export default RequiredInput;
